import React, { useState, useEffect, Children } from "react";
import { EmployeeDataVM, EmployeeTeamVM } from '../../Models/ViewModels';
import { Table, Pagination, Stack, Avatar, Input, Button } from "rsuite";
import * as ProfileDB from '../../Services/EmployeeDB';
import { PageHeader } from "../../SharedComponents/PageHeader";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import { handleDownloadAsExcel } from "../../Helpers/Utils";
import { GetUserLoginID } from "../../Services/UserSessionManager";

import * as userManager from '../../Services/UserSessionManager';
import {  SetRole } from "../../Services/KRAApprovalDB";

const { Column, HeaderCell, Cell } = Table;
const colors = ['pink', 'grey', 'blue', 'yellow', 'purple', 'green', 'red'];

export const ChangeEmployeeRole = ({ name, designation, department }: any) => {
  const[loginid,setLoginid]=useState(GetUserLoginID())


  useEffect(() => {
     SetRole(loginid,'Employee')
     userManager.SetUserToken('');
     sessionStorage.clear();     
     window.location.reload()
     window.location.href='/'

  },[]) 
return <>
       
  </>
}